module.exports = __webpack_public_path__ + "7ef5f530e9bf32f62d1979ba09fa4c30.png";